/**
 * Date formatting utilities
 */

const DEFAULT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DEFAULT_DATE_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
};

const DATE_TIME_24H_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DEFAULT_DATE_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

/**
 * Format a date to short date string (e.g., "Nov 25, 2025")
 */
export function formatDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString('en-US', DEFAULT_DATE_OPTIONS);
}

/**
 * Format a date to date-time string (e.g., "Nov 25, 2025, 10:30 AM")
 */
export function formatDateTime(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString('en-US', DATE_TIME_OPTIONS);
}

/**
 * Format a date to 24h date-time string (e.g., "Nov 25, 2025, 14:30")
 */
export function formatDateTime24h(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString('en-US', DATE_TIME_24H_OPTIONS);
}
